import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MyDayOffPage from './pages/MyDayOffPage';
import MyDayOffDetailPage from './pages/MyDayOffDetailPage';

const MyDayOffModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MyDayOffPage />} />
      <Route path="/:applicationId" element={<MyDayOffDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MyDayOffModule;
